import IconListCheck from '@fortuneo/ui-icons/specials/IconListCheck'
import React, { type FC, type PropsWithChildren } from 'react'

const CheckIcon = () => (
  <IconListCheck className="fill-theme-primary-accent3" size={24} />
)

const FirstCell: FC<PropsWithChildren> = ({ children }) => (
  <td className="py-6 text-085 font-medium leading-alternate">{children}</td>
)

const AmexCardsComparator: FC = () => (
  <div className="w-full overflow-x-auto rounded-md border border-solid border-theme-default-accent2 bg-background-default p-8 shadow-[0_5px_10px_0_rgb(35,35,35,0.06)] tablet:p-12">
    <table className="border-collapse">
      <thead>
        <tr className="border-b border-solid border-border-default">
          <td className="min-w-[100px] pb-8 pr-20 tablet:min-w-[350px]"></td>
          <td className="pb-8 pl-12 pr-10 align-bottom text-130 font-medium leading-alternate">
            La Blue d'American Express®
          </td>
          <td className="pb-8 pr-10 align-bottom text-130 font-medium leading-alternate">
            Carte Green American Express®
          </td>
          <td className="pb-8 pr-10 align-bottom text-130 font-medium leading-alternate">
            Carte Gold American Express®
          </td>
          <td className="pb-8 align-bottom text-130 font-medium leading-alternate">
            Carte Platinum American Express®
          </td>
        </tr>
      </thead>
      <tbody>
        <tr className="border-b border-solid border-border-default">
          <FirstCell>Garantie Protection des Achats</FirstCell>
          <td className="pl-12">
            <CheckIcon />
          </td>
          <td>
            <CheckIcon />
          </td>
          <td>
            <CheckIcon />
          </td>
          <td>
            <CheckIcon />
          </td>
        </tr>
        <tr className="border-b border-solid border-border-default">
          <FirstCell>Assurance Accidents de Voyages</FirstCell>
          <td className="pl-12">
            <CheckIcon />
          </td>
          <td>
            <CheckIcon />
          </td>
          <td>
            <CheckIcon />
          </td>
          <td>
            <CheckIcon />
          </td>
        </tr>
        <tr className="border-b border-solid border-border-default">
          <FirstCell>Assistance aux Voyages</FirstCell>
          <td className="pl-12">
            <CheckIcon />
          </td>
          <td>
            <CheckIcon />
          </td>
          <td>
            <CheckIcon />
          </td>
          <td className="pb-6 text-085">
            Couverture additionnelle avec Assurances Platinum
          </td>
        </tr>
        <tr className="border-b border-solid border-border-default">
          <FirstCell>Garantie Incidents de Voyages</FirstCell>
          <td className="pl-12"></td>
          <td>
            <CheckIcon />
          </td>
          <td>
            <CheckIcon />
          </td>
          <td>
            <CheckIcon />
          </td>
        </tr>
        <tr className="border-b border-solid border-border-default">
          <FirstCell>Garantie Annulation et Report de Voyage</FirstCell>
          <td className="pl-12"></td>
          <td></td>
          <td>
            <CheckIcon />
          </td>
          <td>
            <CheckIcon />
          </td>
        </tr>
        <tr className="border-b border-solid border-border-default">
          <FirstCell>Garantie Interruption de Déplacement</FirstCell>
          <td className="pl-12"></td>
          <td></td>
          <td>
            <CheckIcon />
          </td>
          <td>
            <CheckIcon />
          </td>
        </tr>
        <tr className="border-b border-solid border-border-default">
          <FirstCell>Assistance Médicale et Frais Médicaux</FirstCell>
          <td className="pl-12"></td>
          <td></td>
          <td>
            <CheckIcon />
          </td>
          <td>
            <CheckIcon />
          </td>
        </tr>
        <tr className="border-b border-solid border-border-default">
          <FirstCell>Garantie Véhicule de Location</FirstCell>
          <td className="pl-12"></td>
          <td></td>
          <td>
            <CheckIcon />
          </td>
          <td>
            <CheckIcon />
          </td>
        </tr>
      </tbody>
    </table>
  </div>
)

export default AmexCardsComparator
